import React, { useState } from 'react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Cómo recibo el producto?',
    answer: 'Inmediatamente después de tu compra, recibirás un email con el enlace de descarga. El acceso es instantáneo y permanente.'
  }, {
    question: '¿Cuánto tarda el acceso?',
    answer: 'El acceso es inmediato. En menos de 2 minutos después de tu compra ya estarás descargando el contenido.'
  }, {
    question: '¿Necesito conocimientos previos?',
    answer: 'No. Realmanifestación está diseñado para cualquier persona, sin importar su nivel. Todo está explicado paso a paso.'
  }, {
    question: '¿Funciona si ya intenté otras cosas?',
    answer: 'Sí. Este método está diseñado específicamente para personas que ya intentaron otras técnicas sin resultados. El enfoque trabaja desde la identidad, no desde la superficie.'
  }, {
    question: '¿Cómo es la garantía?',
    answer: 'Tienes 7 días para probar el método. Si no estás satisfecho, te devolvemos el 100% de tu dinero sin preguntas.'
  }, {
    question: '¿En qué dispositivos puedo verlo?',
    answer: 'Desde cualquier dispositivo: celular, tablet, computadora. El formato es PDF optimizado para cualquier pantalla.'
  }, {
    question: '¿Es un curso o un libro?',
    answer: 'Es un sistema completo. Contenido teórico, protocolos prácticos, ejercicios, meditaciones. Más de 200 recursos en un solo lugar.'
  }, {
    question: '¿Hay soporte?',
    answer: 'Sí. Además del contenido, tienes acceso al grupo privado donde podés hacer preguntas y conectar con otras personas.'
  }];
  return <section className="px-4 py-7 sm:py-9 bg-dark-card/30 border-t border-brand-gold/10" data-id="element-71">
      <div className="max-w-3xl mx-auto" data-id="element-72">
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-5 sm:mb-6" data-id="element-73">
          Preguntas frecuentes
        </h2>

        <div className="space-y-2" data-id="element-74">
          {faqs.map((faq, i) => <div key={i} className="border border-brand-gold/20 rounded-lg overflow-hidden" data-id="element-75">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-3.5 text-left hover:bg-dark-card/50 transition-colors" data-id="element-76">
                <span className="font-semibold text-sm pr-4" data-id="element-77">
                  {faq.question}
                </span>
                <span className="text-brand-gold text-lg flex-shrink-0 leading-none" data-id="element-78">
                  {openIndex === i ? '−' : '+'}
                </span>
              </button>
              {openIndex === i && <div className="px-3.5 pb-3.5 text-sm text-brand-gray border-t border-brand-gold/10" data-id="element-79">
                  <p className="pt-2.5" data-id="element-80">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}